class Incrementer {
  constructor(options = {}) {
    this.config = {
      module: document.querySelectorAll('[data-module="incrementer"]'),
      ...options
    };
  }

  init() {
    const { module } = this.config;

    module.forEach(incrementer => {
      const buttonMinus = incrementer.querySelector('[data-type="minus"]');
      const buttonPlus = incrementer.querySelector('[data-type="plus"]');
      const quantityElement = incrementer.querySelector('input[name="quantity"]');
      buttonMinus.addEventListener('click', () => {
        if (parseInt(quantityElement.value, 10) > 1) {
          quantityElement.value = parseInt(quantityElement.value, 10) - 1;
        }
      });
      buttonPlus.addEventListener('click', () => {
        quantityElement.value = parseInt(quantityElement.value, 10) + 1;
      });
    });
  }
}

export default Incrementer;
